<template lang="pug">
  div( class="full-width")
    v-flex( xs12 class="px-4 mt-3")
      v-form(
        v-model="valid"
        class="credit-form"
        ref="loanApplication"
      )
        div(
          v-for="field in addressFormDataPageOne"
          class="text-container"
        )
          v-text-field(
            :key="field.v_model_name"
            :id="field.id"
            :label="field.label"
            :placeholder="field.placeholder"
            v-model="customerDataCopy[field.v_model_name]"
            :rules="checkRules(field, _data)"
            :required="field.required"
            :mask="field.mask"
            validate-on-blur
            @focus="showDisclaimer(field.v_model_name)"
            @blur="hideDisclaimer(field.v_model_name)"
          )
          disclaimer-tooltip(
            v-if="greenskyPreQual && field.greenskyPreQualDisclaimerText"
            v-model="disclaimers[field.v_model_name]"
            :text="tooltipText(field)"
            :id="field.disclaimerId"
          )
          disclaimer-tooltip(
            v-else-if="lenderName === 'greensky' && field.hasDisclaimer"
            v-model="disclaimers[field.v_model_name]"
            :text="tooltipText(field)"
            :id="field.disclaimerId"
          )

        v-text-field(
          v-if="lenderName !== 'wellsfargo'"
          :id="dateOfBirthDataPageOne.id"
          :label="dateOfBirthDataPageOne.label"
          :placeholder="dateOfBirthDataPageOne.placeholder"
          v-model="customerDataCopy[dateOfBirthDataPageOne.v_model_name]"
          :rules="dateOfBirthDataPageOne.rules"
          :required="dateOfBirthDataPageOne.required"
          :mask="dateOfBirthDataPageOne.mask"
          @focus="showDisclaimer(dateOfBirthDataPageOne.v_model_name)"
          @blur="hideDisclaimer(dateOfBirthDataPageOne.v_model_name)"
          validate-on-blur
          @keyup.enter="submitForm"
        )
        disclaimer-tooltip(
          v-model="disclaimers.dateOfBirth"
          v-if="greenskyPreQual"
          :text="tooltipText(dateOfBirthDataPageOne)"
          :id="dateOfBirthDataPageOne.disclaimerId"
        )
        disclaimer-tooltip(
          v-model="disclaimers.dateOfBirth"
          v-else-if="lenderName === 'greensky'"
          :text="tooltipText(dateOfBirthDataPageOne)"
          :id="emailFormDataPageOne.disclaimerId"
        )

        v-text-field(
          :id="emailFormDataPageOne.id"
          :label="emailFormDataPageOne.label"
          :placeholder="emailFormDataPageOne.placeholder"
          v-model="customerDataCopy[emailFormDataPageOne.v_model_name]"
          :rules="emailFormDataPageOne.rules"
          :required="emailFormDataPageOne.required"
          :mask="emailFormDataPageOne.mask"
          @focus="showDisclaimer('email')"
          @blur="hideDisclaimer('email')"
          validate-on-blur
          @keyup.enter="submitForm"
        )
        disclaimer-tooltip(
          v-model="disclaimers.email"
          v-if="greenskyPreQual"
          :text="tooltipText(emailFormDataPageOne)"
          :id="emailFormDataPageOne.disclaimerId"
        )
        disclaimer-tooltip(
          v-model="disclaimers.email"
          v-else-if="lenderName === 'greensky'"
          :text="tooltipText(emailFormDataPageOne)"
          :id="emailFormDataPageOne.disclaimerId"
        )

        div(
            v-if="lenderName === 'wellsfargo'"
          )
            //- TODO: Add v-model for checked Wells Fargo consent
            v-checkbox(
              :label="wellsfargoConsent"
              v-model="termsConsent"
              id="form-data-page-one-terms-checkbox"
            )
      div(v-if="lenderName === 'greensky'")
        fan-loader(
            :loading="validatingEmail"
          )
            div(slot="loadingMsg"
              class="full-width text-xs-center my-2") We are verifying your email...
        div(
          v-if="unverifiableEmail"
          class="email-validation-msg"
        )
          p Unverifiable email, Please enter a verifiable email.

    v-flex( xs12 class="px-4")
      AppNextButton( 
        v-if="lenderName === 'wellsfargo'"
        class="next-btn"
        :buttonFunction="submitForm"
        :disabled="!termsConsent"
      ) Next
      AppNextButton( 
        v-else-if="lenderName === 'greensky'"
        class="next-btn"
        :buttonFunction="submitForm"
        :disabled="validatingEmail"
      ) Next
      AppNextButton( 
        v-else
        class="next-btn"
        :buttonFunction="submitForm"
      ) Next
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import DisclaimerTooltip from 'Components/DisclaimerTooltip.vue'
  import { mapActions, mapState } from 'vuex'
  import { FormPageMixin } from 'Mixins/FormPageMixin.js'
  import { formDataPageOne, emailFormData, dateOfBirthData, ageDisclaimer } from 'Helpers/CreditApplicationFormHelper.js'
  import DatePicker from './DatePicker.vue'
  import FanLoader from 'Components/FanLoader.vue'

  export default {
    name: 'CreditFormPageOne',
    components: {
      AppNextButton,
      DisclaimerTooltip,
      DatePicker,
      FanLoader
    },
    mixins: [
      FormPageMixin
    ],
    props: {
      unverifiableEmail: {
        type: Boolean
      },
      validatingEmail: {
        type: Boolean
      }
    },
    data () {
      return {
        checked: false,
        date: null,
        menu: false,
        termsConsent: false,
        // added variables to be reactive and update when greensky legal content is fetched
        addressFormDataPageOne: [],
        dateOfBirthDataPageOne: [],
        emailFormDataPageOne: [],
        // -----
        formDataPageOne,
        emailFormData,
        dateOfBirthData,
        ageDisclaimer,
        disclaimers: {
          dateOfBirth: false,
          email: false,
          streetAddress: false,
        },
        wellsfargoConsent: "I acknowledge that by checking the box and selecting ‘Next,” OnCall Air Finance+ will forward my information  to Wells Fargo Bank, N.A. (“Wells Fargo”). Wells Fargo will use my information for purposes of completing a credit application."
      }
    },
    computed: {
      ...mapState({
        hasPreQual: state => state.preQualification.hasPreQual
      }),
      greenskyPreQual() {
        return this.lenderName === 'greensky' && this.hasPreQual
      },
    },
    watch:{
      termsConsent(val) {
        console.log(val)
      }
    },
    methods: {
      ...mapActions(['submitApplication', 'getGreenskyLegalContent']),
      hideDisclaimer (key) {
        this.$set(this.disclaimers, key, false)
      },
      showDisclaimer (key) {
        this.$set(this.disclaimers, key, true)
      },
      checkRules(field, _data) {
        return field.rules(_data)
      }
    },
    async mounted(){
      if (this.lenderName === 'greensky'){
        this.addressFormDataPageOne = await this.getGreenskyLegalContent(formDataPageOne)
        this.dateOfBirthDataPageOne = await this.getGreenskyLegalContent(dateOfBirthData)
        this.emailFormDataPageOne = await this.getGreenskyLegalContent(emailFormData)
      } else{
        this.addressFormDataPageOne = formDataPageOne()
        this.dateOfBirthDataPageOne = dateOfBirthData()
        this.emailFormDataPageOne = emailFormData()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .text-container {
    width: 100%;
    overflow: auto;
    white-space: wrap;
  }

  .email-validation-msg {
    color: red;
  }
</style>
